<template>
    <header class="container-fluid">
        <div class="col">
            <router-link v-if="!hideLogo" to="/" class="header-logo"><img src="../assets/FlightSchool_Logo_DDFF00.png" /></router-link>
            <nav>
                <!-- <router-link v-if="!hideFAQ" target="_blank" to="/faq">FAQ</router-link> -->
                <a href="https://www.swift.co" target="_blank">SWIFT.CO</a>
                <a href="https://instagram.com/swift_flightschool" target="_blank"><span class="instagram_icon"></span></a>
            </nav>
        </div>
    </header>
</template>

<script>
export default {
    name: 'FlightHeader',
    data() {
        return {
            applicationDeadline: "March 27, 2020"
        }
    },
    props: {
        hideFAQ: Boolean,
        hideLogo: Boolean,
        hideAppDueDate: Boolean
    },
    created: function() {
        if (this.hideAppDueDate) {
            document.querySelector('.sticky-marquee').classList.add('sticky-marquee-hidden')
        }
    }
}
</script>

<style lang="scss" scoped>
.router-link-active {
    text-decoration: underline;
}
</style>